import Swiper from 'swiper/bundle';

function initSliderGalery() {
	document.querySelectorAll(".slide-galery-container").forEach(slide => {
		const nextButton = slide.querySelector(".swiper-button-next");
		const prevButton = slide.querySelector(".swiper-button-prev");

		const swiper = 	new Swiper(slide, {
			slidesPerView: "auto",
			spaceBetween: 0,
			centeredSlides: true,
			grabCursor: 'true',

			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
		});
	});
}

if (document.querySelector(".slide-galery-container")) {
	initSliderGalery();
}
